import { createContext } from 'react';
export const SVMExternalContext = createContext(false);
//# sourceMappingURL=SVMExternalContext.js.map